// A per-browser anonymous identifier. There's no login system for this
// game, so this is generated once and persisted in localStorage, letting
// the backend correlate logs from the same browser across visits.
const STORAGE_KEY = 'jokes_scrambler_player_id';

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID (older browsers, jsdom).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getPlayerId() {
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateUuid();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (e) {
    // localStorage can be unavailable (private browsing, storage disabled, etc.)
    return null;
  }
}

// Overwrites the stored id with an account's own canonical player uuid
// (returned by register/login/me) - so a returning logged-in player keeps
// using the identity their history (seen jokes, reset count) is attached
// to, rather than whatever uuid this particular browser happened to have.
export function setPlayerId(id) {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch (e) {
    // ignore - same unavailable-storage case as above
  }
}
